export default __webpack_public_path__ + "static/media/no_dish_picture.de72c89b.svg";